import React from 'react'
import Button from '../button'

import S from './styled'

const defaultItem = {
  version: '1.0.12',
}

const History = ({ title, item = defaultItem }) => (
  <S.History>
    <label>Version: {item.version}</label>
    <Button blue onClick={() => ({})}>History</Button>
  </S.History>
)

export default History
